module.exports = __webpack_public_path__ + "media/images/bindingAccount/icon_fb-5ca3a53bc3e6eb5a03043a743b24e413.svg";